<template>
    <div ref="apprenticeSwiper"
         class="swiper swiper-container">
        <div class="swiper-wrapper">

            <!-- Has no slides -->
            <div class="no-slide" v-if="slides === 0">
               {{$t('components.no_slides_found')}}
            </div>

            <!-- Slides -->
            <div class="swiper-slide" v-for="slide in slides">
                <slot :name="`slide-${slide - 1}`"></slot>
            </div>
        </div>

        <!-- Navigation arrows -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>

        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
import Swiper, {Navigation, Pagination, Scrollbar, A11y, Controller} from "swiper";
import 'swiper/swiper-bundle.min.css'

export default {
    name: "design-2021-apprentice-swiper-component",
    props: {
        enableNavigation: {
            type: Boolean,
            required: false,
            default: false,
        },

        enablePagination: {
            type: Boolean,
            required: false,
            default: false,
        },

        enableScrollbar: {
            type: Boolean,
            required: false,
            default: false,
        },

        enableA11y: {
            type: Boolean,
            required: false,
            default: false,
        },

        modules: {
            type: Array,
            required: false,
            default: () => {
                return [Navigation, Pagination, Scrollbar, A11y];
            }
        },

        navigation: {
            type: Object,
            required: false,
            default: () => {
                return {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
        },

        breakpoints: {
            type: Object,
            required: false,
            default: () => {},
        },

        pagination: {
            type: Object,
            required: false,
            default: () => {
                return {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
        },

        scrollbar: {
            type: Object,
            required: false,
            default: () => {
                return {
                    el: '.swiper-scrollbar',
                }
            }
        },

        slidesPerView: {
            type: Number,
            required: false,
            default: 1,
        },

        spaceBetween: {
            type: Number,
            required: false,
            default: 30,
        },

        centerInsufficientSlides: {
            type: Boolean,
            required: false,
            default: false,
        },

        slideToClickedSlide: {
            type: Boolean,
            required: false,
            default: false,
        },

        centeredSlides: {
            type: Boolean,
            required: false,
            default: false,
        },

        centeredSlidesBounds: {
            type: Boolean,
            required: false,
            default: false,
        },

        loop: {
            type: Boolean,
            required: false,
            default: false,
        },

        a11y: {
            prevSlideMessage: 'Vorige slide',
            nextSlideMessage: 'Volgende slide',
        },

        slides: {
            type: Number,
            required: false,
            default: 0,
        },

    },
    data() {
        return {
            activeIndex: 0,
            options: {
                slidesPerView: this.slidesPerView,
                spaceBetween: this.spaceBetween,
                centerInsufficientSlides: this.centerInsufficientSlides,
                slideToClickedSlide: this.slideToClickedSlide,
                centeredSlides: this.centeredSlides,
                centeredSlidesBounds: this.centeredSlidesBounds,
                modules: this.modules,
                loop: this.loop,
                pagination: this.enablePagination ? this.pagination : {},
                navigation: this.enableNavigation ? this.navigation : {},
                scrollbar: this.enableScrollbar ? this.scrollbar : {},
                breakpoints: this.breakpoints,
                a11y: this.enableA11y ? this.a11y : {},
            }
        }
    },

    mounted() {
        new Swiper(this.$refs.apprenticeSwiper, this.options);
    },
}
</script>

<style scoped lang="scss">

</style>
